import React from 'react';
import { Link } from 'react-router-dom';
import { sampleProducts } from '../data/products';

export default function OrderProducts() {
  return (
    <div className="page-wrapper">
      <div className="container">
        <div className="notification success" style={{ marginBottom: '1.5rem' }}>
          Scott's sample eCommerce Site allows you to click on 'Details' below and sample how to order a product.
          You can register then order a product, but you will not be billed and no products will be shipped.
        </div>

        <div className="products-grid">
          {sampleProducts.map(product => (
            <div className="product-card" key={product.id}>
              {product.images && product.images.length > 0 ? (
                <img
                  src={product.images[0].imageUrl}
                  alt={product.title}
                  onError={e => { e.target.src = 'https://placehold.co/500x600/png'; }}
                />
              ) : (
                <img src="https://placehold.co/500x600/png" alt={product.title} />
              )}
              <div className="product-card-body">
                <p className="product-title">{product.title}</p>
                <p className="product-author">by <b>{product.author}</b></p>
                <div className="product-price">
                  <p style={{ marginBottom: '0.2rem' }}>List Price: <span className="list-price">${product.listPrice.toFixed(2)}</span></p>
                  <p>As low as: <span className="as-low">${product.price100.toFixed(2)}</span></p>
                </div>
              </div>
              <div className="product-card-footer">
                <Link to={`/products/${product.id}`} className="btn btn-primary btn-block">Details</Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
